import React, { useState } from 'react';
import MDialog from '../../../../components/controls/MDialog';
import { FormControlLabel, Grid, Stack, Switch, Typography, LinearProgress } from '@mui/material';
import RCBarChart from '../../../../components/charts/recharts/rcBarChart';
import RCPieChart from '../../../../components/charts/recharts/rcPieChart';
import { buildQueryString, dataProvider } from '../../../../DataProvider';
import { useNotify } from 'react-admin';

interface IData {
    [key: string]: any;
}

const ChartView: React.FC<IData> = (props) => {
    const { chart, setChart } = props;
    const filter = chart.filterList;
    const notify = useNotify();
    const [isLoading, setIsLoading] = React.useState(false);
    const [data, setData] = useState<any[]>([]);

    React.useEffect(() => {
        setIsLoading(true);
        dataProvider.fetchData('MappingErrorReport', `ViewChart/Filter${convertFilter(filter)}`
        ).then((result: any) => {
            setData(convertData(result.data?.items));
        }).catch((err: any) => {
            notify(`Fail to fetch data: ${err}`, { type: 'error', autoHideDuration: 2000 });
        }).finally(_ => setIsLoading(false));
    }, []);

    const convertFilter = (filter: any) => {
        let _filter = buildQueryString({ filter: filter }, { top: 1000000, skip: 0, orderBy: 'reported_date desc' });
        return _filter;
    };

    const convertData = (data: any) => {
        let newData: any[] = [];
        data?.forEach((element: any) => {
            if (element.firstName && !newData.find((x: any) => x.name.includes(element.firstName))) {
                newData.push({
                    name: element.firstName,
                    error: data?.filter((x: any) => x.receiver === element.receiver)?.length,
                });
            }
        });
        return newData.sort((a: any, b: any) => a.name.localeCompare(b.name));
    };
    return (
        <>
            <MDialog
                maxWidth={'xl'}
                open={chart.open}
                handleClose={() => setChart(prev => ({ ...prev, open: false, type: 'bar' }))}
                name={'order-mistake-dialog'}
                action={
                    <Stack direction="row" justifyContent={'space-between'} width="100%">
                        <FormControlLabel
                            value="pie"
                            control={<Switch color="primary" onChange={(ev) => setChart(prev => ({ ...prev, type: ev.target.checked ? 'pie' : 'bar' }))} />}
                            label="Pie chart"
                            labelPlacement="start"
                        />
                    </Stack>
                }
                children={
                    <>
                        {isLoading === true && <LinearProgress color='secondary' />}
                        <Typography sx={{ marginBottom: '10px' }} variant="h3" textAlign={'center'}>Mapping Error Count</Typography>
                        {data.length && chart.type === 'bar' &&
                            (<RCBarChart
                                width={1500}
                                data={data}
                                barSize={data.length > 18 ? 50 : ((data.length > 8) ? 70 : 90)}
                                yGap={5}
                                xAxis={{ dataKey: 'name', label: { value: 'USER', dy: 20 } }}
                                yAxis={{ position: 'insideLeft', label: { value: 'Error', angle: -90, dx: -10 } }}
                                legend={'hide'}
                                showTotal={true}
                                seriesList={[
                                    { dataKey: 'error', name: 'Error', fill: '#f44336', stackId: 'a', labelList: { fill: 'white' } },
                                ]}
                            >
                            </RCBarChart>)
                            ||
                            (
                                <Grid container alignItems="center" sx={{ minHeight: '65vh' }}
                                    justifyContent="center" spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} >
                                    <RCPieChart
                                        data={data}
                                        dataKey={'name'}
                                        height={220}
                                        width={450}
                                        chartSize={80}
                                        elevation={20}
                                        seriesList={[
                                            { dataKey: 'error', name: 'Error', fill: '#f44336' },
                                        ]}
                                    >
                                    </RCPieChart>
                                </Grid>
                            )
                        }
                    </>
                }
            >
            </MDialog>
        </>
    );
};
export default ChartView;
